import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import Reports from "./Reports";
import Restaurants from "./Restaurants";
import CreateNewRestaurant from "./CreateNewRestaurant";
// import EditRestaurant from "./EditRestaurant";
import Dashboard from "./Dashboard";
import Orders from "./Orders";
import CashierPage from "./CashierPage";
import QRCode from "./QRCode";
import Users from "./Users";
import Menu from "./Menu";
import LicensePlans from "./LicensePlans";
import SmsPackages from "./SmsPackages";
import OrderRoutines from "./OrderRoutines";
import Test from "./test";
import MyOrder from "./MyOrder";
import Setting from "./Setting";
import SubscriptionResult from "./SubscriptionResult";
import ChargeSMSResult from "./ChargeSMSResult";
import RestaurantsListt from "./Club/RestaurantsListt";
import Loading from "../components/Loading";
import Notifi from "../assets/bell.mp3";
import CustomerGroups from "./Club/CustomerGroups";
import NotFound from "./NotFound2";
import qs from "qs";

import {
  BaseUrl,
  Authorization,
  isUser,
  LogoutFunction,
  ServerSocket,
} from "../static.js";
import { toast } from "react-toastify";
import { io } from "socket.io-client";
import { useStore } from "../store";

export default class RestaurantsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      serverResponse: false,
      showMyOrder: false,
      butArray: [],
      butoArray: [],
      subscriptionType: 0,
    };

    this.notifiSound = new Audio(Notifi);
  }

  componentWillUnmount() {
    ServerSocket.off("connect");
    ServerSocket.off("editOrder");
    if (isUser) {
      ServerSocket.off("reciveOrder");
    } else {
      ServerSocket.off("createNewOrder");
    }
  }

  componentDidMount() {
    let data = {
      businessCode: localStorage.getItem("code"),
    };

    data = Object.assign(data, Authorization());

    fetch(BaseUrl + "checkToken", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log("checkToken: ", result);
        if (result.status === 200) {
          this.setState({
            serverResponse: true,
            butArray: isUser ? result.butArray : [],
            butoArray: isUser ? result.butoArray : [],
            subscriptionType: result.subscriptionType,
          });

          ServerSocket.connect();
          ServerSocket.on("error", (error) => {
            console.log("error: ", error);
          });

          ServerSocket.on("reconnect_error", (error) => {
            console.log("reconnect_error: ", error);
          });

          ServerSocket.on("reconnect_failed", (error) => {
            console.log("reconnect_failed: ", error);
          });

          ServerSocket.on("connect", () => {
            console.log("====================================");
            console.log("connected");
            console.log("====================================");

            if (isUser) {
              ServerSocket.emit("setSocketId", data);
              ServerSocket.on("reciveOrder", (data) => {
                if (
                  this.props.location.pathname
                    .toLowerCase()
                    .trim()
                    .endsWith("orders") ||
                  this.props.location.pathname
                    .toLowerCase()
                    .trim()
                    .endsWith("cashier")
                )
                  return;
                console.log("reciveOrder: ", data);

                let place = "";
                switch (data.BUT) {
                  case "KDS": {
                    place = "آشپزخانه: ";
                    break;
                  }
                  case "Manager": {
                    place = "مدیر داخلی: ";
                    break;
                  }
                  case "Cashier": {
                    place = "صندق‌دار: ";
                    break;
                  }
                  case "Waiter": {
                    place = "گارسون: ";
                    break;
                  }
                  default:
                    break;
                }
                console.log("141");
                if (place) {
                  this.notifiSound.play();
                  toast.success(
                    place + "سفارش جدید برای  " + data.orderStationName,
                    {
                      position: toast.POSITION.BOTTOM_RIGHT,
                      hideProgressBar: true,
                      autoClose: 6000,
                      toastClassName: "toast",
                      onClick: () => {
                        this.onMyOrderClick(
                          localStorage.getItem("code"),
                          data.BUT
                        );
                      },
                    }
                  );
                }
              });

              ServerSocket.on("reciveOrder-edited", (data) => {
                console.log(data);
                if (
                  this.props.location.pathname
                    .toLowerCase()
                    .trim()
                    .endsWith("orders") ||
                  this.props.location.pathname
                    .toLowerCase()
                    .trim()
                    .endsWith("cashier")
                )
                  return;
                toast.success("سفارش " + data.orderStationName + " ویرایش شد", {
                  position: toast.POSITION.BOTTOM_RIGHT,
                  hideProgressBar: true,
                  autoClose: 6000,
                  toastClassName: "toast",
                  onClick: () => {
                    this.onMyOrderClick(localStorage.getItem("code"), data.BUT);
                  },
                });
              });
            } else {
              ServerSocket.emit(
                "setSocketId",
                Object.assign(data, Authorization())
              );

              ServerSocket.on("createNewOrder", (data) => {
                if (
                  this.props.location.pathname
                    .toLowerCase()
                    .trim()
                    .endsWith("orders") ||
                  this.props.location.pathname
                    .toLowerCase()
                    .trim()
                    .endsWith("cashier")
                )
                  return;
                this.notifiSound.play();
                toast.success("سفارش جدید برای  " + data[0].orderStationName, {
                  position: toast.POSITION.BOTTOM_RIGHT,
                  hideProgressBar: true,
                  autoClose: 6000,
                  toastClassName: "toast",
                  onClick: () => this.onNotifiClick(data[0].businessCode),
                });
              });

              ServerSocket.on("editOrder", (data) => {
                if (
                  this.props.location.pathname
                    .toLowerCase()
                    .trim()
                    .endsWith("orders") ||
                  this.props.location.pathname
                    .toLowerCase()
                    .trim()
                    .endsWith("cashier")
                )
                  return;
                console.log("editOrder_resList: ", data);

                toast.success(
                  "سفارش " + data[0].orderStationName + " ویرایش شد",
                  {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    hideProgressBar: true,
                    autoClose: 6000,
                    toastClassName: "toast",
                    onClick: () => {
                      this.onNotifiClick(data[0].businessCode);
                    },
                  }
                );
              });
            }
          });
        } else {
          LogoutFunction();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  onNotifiClick(code) {
    this.props.history.push(this.props.match.path + `/${code}/Orders`);
  }

  onCreateNewRestaurant() {
    this.props.history.push(this.props.match.path + "/CreateNew");
  }

  onEditRestaurant(code) {
    this.props.history.push(this.props.match.path + `/${code}/Edit`);
  }

  onClickRestaurant(code) {
    this.props.history.push(this.props.match.path + `/${code}`);
  }

  onCreateNewRestaurantNext(code) {
    this.props.history.push(this.props.match.path + `/${code}/Menu`);
  }

  onOrdersClick(code) {
    this.props.history.push(this.props.match.path + `/${code}/Orders`);
  }

  onCashierClick(code) {
    this.props.history.push(this.props.match.path + `/${code}/Cashier`);
  }

  onQRCodeClick(code) {
    this.props.history.push(this.props.match.path + `/${code}/QR`);
  }

  onUsersClick(code) {
    this.props.history.push(this.props.match.path + `/${code}/Users`);
  }

  onSubscriptionClick(code) {
    this.props.history.push(this.props.match.path + `/${code}/Subscription`);
  }

  onBuySmsClick(code) {
    this.props.history.push(this.props.match.path + `/${code}/SmsPackages`);
  }

  onMenuClick(code) {
    this.props.history.push(this.props.match.path + `/${code}/Menu`);
  }

  onReportClick(code) {
    this.props.history.push(this.props.match.path + `/${code}/Reports`);
  }

  onClubClick(code) {
    this.props.history.push(this.props.match.path + `/${code}/Club`);
  }

  goToBusinessList() {
    this.props.history.push(this.props.match.path);
  }

  onRulesPurchaseClick(id) {
    this.props.history.push(
      this.props.match.path + `/${id}/Club/RulesPurchase`
    );
  }

  onCustomerGroupsClick(id) {
    this.props.history.push(
      this.props.match.path + `/${id}/Club/CustomerGroups`
    );
  }

  onPollsClick(id) {
    this.props.history.push(this.props.match.path + `/${id}/Club/Polls`);
  }

  onClubReportsClick(id) {
    this.props.history.push(this.props.match.path + `/${id}/Club/Reports`);
  }

  onLicenseClick(id) {
    this.props.history.push(this.props.match.path + `/${id}/Subscription`);
  }

  onOrderRoutinesClick(id) {
    this.props.history.push(this.props.match.path + `/${id}/OrderRoutines`);
  }

  onSettingClick(id) {
    this.props.history.push(this.props.match.path + `/${id}/setting`);
  }
  onMyOrderClick(id, type) {
    this.props.history.push(
      this.props.match.path + `/${id}/` + type + `OrderList`
    );
  }

  render() {
    if (this.state.serverResponse) {
      return (
        <div>
          <Switch>
            {!isUser && (
              <Route
                exact
                path={this.props.match.path}
                render={(props) => (
                  <Restaurants
                    {...props}
                    showLogo={true}
                    onCreateNewRestaurant={this.onCreateNewRestaurant.bind(
                      this
                    )}
                    onEditRestaurant={this.onEditRestaurant.bind(this)}
                    onClickRestaurant={this.onClickRestaurant.bind(this)}
                    onLicenseClick={this.onLicenseClick.bind(this)}
                  />
                )}
              />
            )}
            {!isUser && (
              <Route
                exact
                path={`${this.props.match.path}/CreateNew`}
                render={(props) => (
                  <CreateNewRestaurant
                    {...props}
                    onCreateNewRestaurantNext={this.onCreateNewRestaurantNext.bind(
                      this
                    )}
                  />
                )}
              />
            )}
            {!isUser && (
              <Route
                path={`${this.props.match.path}/:id/Edit`}
                render={(props) => (
                  <CreateNewRestaurant
                    {...props}
                    isEdit={true}
                    onCreateNewRestaurantNext={this.onCreateNewRestaurantNext.bind(
                      this
                    )}
                  />
                )}
              />
            )}
            <Route
              exact
              path={`${this.props.match.path}/:id`}
              render={(props) => (
                <Dashboard
                  {...props}
                  goToBusinessList={this.goToBusinessList.bind(this)}
                  onOrdersClick={this.onOrdersClick.bind(this)}
                  onCashierClick={this.onCashierClick.bind(this)}
                  onMenuClick={this.onMenuClick.bind(this)}
                  onQRCodeClick={this.onQRCodeClick.bind(this)}
                  onReportClick={this.onReportClick.bind(this)}
                  onClubClick={this.onClubClick.bind(this)}
                  onUsersClick={this.onUsersClick.bind(this)}
                  onSubscriptionClick={this.onSubscriptionClick.bind(this)}
                  onBuySmsClick={this.onBuySmsClick.bind(this)}
                  onOrderRoutinesClick={this.onOrderRoutinesClick.bind(this)}
                  onSettingClick={this.onSettingClick.bind(this)}
                  onMyOrderClick={this.onMyOrderClick.bind(this)}
                />
              )}
            />
            {((isUser &&
              (this.state.butArray.indexOf(1) > -1 ||
                this.state.butArray.indexOf(2) > -1 ||
                this.state.butArray.indexOf(3) > -1)) ||
              !isUser) &&
              this.state.subscriptionType !== 3 &&
              this.state.subscriptionType !== 4 && (
                <Route
                  path={`${this.props.match.path}/:id/Orders`}
                  render={(props) => <Orders {...props} />}
                />
              )}

            {((isUser &&
              (this.state.butArray.indexOf(1) > -1 ||
                this.state.butArray.indexOf(2) > -1 ||
                this.state.butArray.indexOf(3) > -1)) ||
              !isUser) &&
              this.state.subscriptionType !== 3 &&
              this.state.subscriptionType !== 4 && (
                <Route
                  path={`${this.props.match.path}/:id/Cashier`}
                  render={(props) => <CashierPage {...props} />}
                />
              )}
            {((isUser && this.state.butArray.indexOf(1) > -1) || !isUser) && (
              <Route
                path={`${this.props.match.path}/:id/Subscription`}
                render={(props) => <LicensePlans {...props} />}
              />
            )}

            {((isUser &&
              this.state.butArray.indexOf(1) > -1 &&
              this.state.subscriptionType !== 3 &&
              this.state.subscriptionType !== 4) ||
              !isUser) &&
              this.state.subscriptionType !== 3 &&
              this.state.subscriptionType !== 4 && (
                <Route
                  path={`${this.props.match.path}/:id/SmsPackages`}
                  render={(props) => <SmsPackages {...props} />}
                />
              )}

            {((isUser &&
              this.state.butoArray.indexOf(3) > -1 &&
              this.state.subscriptionType !== 3 &&
              this.state.subscriptionType !== 4) ||
              !isUser) &&
              this.state.subscriptionType !== 3 &&
              this.state.subscriptionType !== 4 && (
                <Route
                  path={`${this.props.match.path}/:id/OrderRoutines`}
                  render={(props) => <OrderRoutines {...props} />}
                />
              )}
            {((isUser &&
              (this.state.butArray.indexOf(1) > -1 ||
                this.state.butArray.indexOf(2) > -1 ||
                this.state.butArray.indexOf(3) > -1)) ||
              !isUser) &&
              this.state.subscriptionType !== 3 && (
                <Route
                  path={`${this.props.match.path}/:id/QR`}
                  render={(props) => <QRCode {...props} />}
                />
              )}

            {((isUser &&
              this.state.butArray.indexOf(1) > -1 &&
              this.state.subscriptionType !== 3 &&
              this.state.subscriptionType !== 4) ||
              !isUser) &&
              this.state.subscriptionType !== 3 &&
              this.state.subscriptionType !== 4 && (
                <Route
                  path={`${this.props.match.path}/:id/Users`}
                  render={(props) => <Users {...props} />}
                />
              )}

            {((isUser &&
              (this.state.butArray.indexOf(1) > -1 ||
                this.state.butArray.indexOf(2) > -1 ||
                this.state.butArray.indexOf(3) > -1)) ||
              !isUser) && (
              <Route
                path={`${this.props.match.path}/:id/Menu`}
                render={(props) => (
                  <Menu
                    {...props}
                    goToBusinessList={this.goToBusinessList.bind(this)}
                  />
                )}
              />
            )}
            {((isUser &&
              this.state.butArray.indexOf(1) > -1 &&
              this.state.subscriptionType !== 3 &&
              this.state.subscriptionType !== 4) ||
              !isUser) &&
              this.state.subscriptionType !== 3 &&
              this.state.subscriptionType !== 4 && (
                <Route
                  path={`${this.props.match.path}/:id/Reports`}
                  render={(props) => <Reports {...props} />}
                />
              )}

            {!isUser &&
              ((this.state.subscriptionType &&
                this.state.subscriptionType === 6) ||
                useStore.getState().subscriptionType === 6) && (
                <Route
                  path={`${this.props.match.path}/:id/Club`}
                  render={(props) => <RestaurantsListt {...props} />}
                />
              )}

            {((isUser &&
              (this.state.butArray.indexOf(1) > -1 ||
                this.state.butArray.indexOf(2) > -1) &&
              this.state.subscriptionType !== 3 &&
              this.state.subscriptionType !== 4) ||
              !isUser) &&
              this.state.subscriptionType !== 3 &&
              this.state.subscriptionType !== 4 && (
                <Route
                  path={`${this.props.match.path}/:id/Setting`}
                  render={(props) => <Setting {...props} />}
                />
              )}

            {((isUser && this.state.butArray.indexOf(1) > -1) || !isUser) && (
              <Route
                path={`${this.props.match.path}/:id/SubscriptionResult`}
                render={(props) => <SubscriptionResult {...props} />}
              />
            )}
            {((isUser &&
              this.state.butArray.indexOf(1) > -1 &&
              this.state.subscriptionType !== 3 &&
              this.state.subscriptionType !== 4) ||
              !isUser) &&
              this.state.subscriptionType !== 3 &&
              this.state.subscriptionType !== 4 && (
                <Route
                  path={`${this.props.match.path}/:id/ChargeSMSResult`}
                  render={(props) => <ChargeSMSResult {...props} />}
                />
              )}

            {isUser &&
              (this.state.butArray.indexOf(1) > -1 ||
                this.state.butArray.indexOf(2) > -1 ||
                this.state.butArray.indexOf(3) > -1 ||
                this.state.butArray.indexOf(4) > -1) && (
                <Route
                  path={`${this.props.match.path}/:id/ManagerOrderList`}
                  render={(props) => (
                    <MyOrder
                      {...props}
                      onMyOrderClick={this.onMyOrderClick.bind(this)}
                    />
                  )}
                />
              )}
            {isUser &&
              (this.state.butArray.indexOf(1) > -1 ||
                this.state.butArray.indexOf(2) > -1 ||
                this.state.butArray.indexOf(3) > -1 ||
                this.state.butArray.indexOf(4) > -1) && (
                <Route
                  path={`${this.props.match.path}/:id/KDSOrderList`}
                  render={(props) => (
                    <MyOrder
                      {...props}
                      onMyOrderClick={this.onMyOrderClick.bind(this)}
                    />
                  )}
                />
              )}
            {isUser &&
              (this.state.butArray.indexOf(1) > -1 ||
                this.state.butArray.indexOf(2) > -1 ||
                this.state.butArray.indexOf(3) > -1 ||
                this.state.butArray.indexOf(4) > -1) && (
                <Route
                  path={`${this.props.match.path}/:id/WaiterOrderList`}
                  render={(props) => (
                    <MyOrder
                      {...props}
                      onMyOrderClick={this.onMyOrderClick.bind(this)}
                    />
                  )}
                />
              )}
            {isUser &&
              (this.state.butArray.indexOf(1) > -1 ||
                this.state.butArray.indexOf(2) > -1 ||
                this.state.butArray.indexOf(3) > -1 ||
                this.state.butArray.indexOf(4) > -1) && (
                <Route
                  path={`${this.props.match.path}/:id/CashierOrderList`}
                  render={(props) => (
                    <MyOrder
                      {...props}
                      onMyOrderClick={this.onMyOrderClick.bind(this)}
                    />
                  )}
                />
              )}
            <Route
              path={`${this.props.match.path}/:id/Test`}
              render={(props) => <Test {...props} />}
            />
            <Route component={NotFound} />
          </Switch>
        </div>
      );
    } else {
      return <Loading />;
    }
  }
}
